import { defineStore } from 'pinia'
import { ref, computed, watch } from 'vue'
// import { useRouter, useRoute } from 'vue-router'
import {
  addMyCar,
  deleteMyCar,
  setMyCarFavourite,
  getCarSelectOptions,
  getMyCarList,
  getCarListByFilter
} from '@/views/garage/api'
import { CarItem } from '@/views/garage/type'

export const useGarageStore = defineStore('garage', () => {
  const carList = ref<CarItem[]>([])
  const selectedCar = ref<CarItem>({})
  const usedCar = ref<CarItem>({})
  const client = ref('')
  const favoriteCar = computed(() => {
    return carList.value[0] || {}
  })

  const updateSelectedCar = (car: CarItem) => {
    selectedCar.value = car
  }

  watch(carList, (newVal) => {
    if (newVal) {
      confirmSelectedCar(newVal[0], 'auto')
    }
  })

  const confirmSelectedCar = (carInfo: CarItem, action?: string) => {
    usedCar.value = carInfo
    try {
      const dataStr = JSON.stringify(carInfo)
      window.parent.postMessage(
        {
          type: 'updateSelectedCar',
          action,
          dataStr
        },
        '*'
      )
    } catch (e) {
      console.log('e', e)
    }
    // 确认了，就清空选择的
    selectedCar.value = {}
  }

  const getGarageCarList = async (params={}) => {
    const res = await getMyCarList(params)
    carList.value = res.data
    return res.data
  }

  const getOptions = async (params) => {
    const res = await getCarSelectOptions(params)
    return res
  }

  const getCarListBySelect = async (params) => {
    const res = await getCarListByFilter(params)
    return res
  }

  const doAddMyCar = async () => {
    const res = await addMyCar(selectedCar.value)
    confirmSelectedCar(selectedCar.value, 'add')
    if (res.success) {
      await getGarageCarList({})
    }
    return res
  }
  const doUpdateFavorite = async (params) => {
    const res = await setMyCarFavourite(params)
    confirmSelectedCar(selectedCar.value, 'update')
    return res
  }
  const doDeleteMyCar = async (params) => {
    const res = await deleteMyCar(params)
    confirmSelectedCar(selectedCar.value, 'delete')
    return res
  }

  const updateClient = (v) => {
    client.value = v
  }

  return {
    selectedCar,
    carList,
    favoriteCar,
    client,
    updateClient,
    getGarageCarList,
    updateSelectedCar,
    confirmSelectedCar,
    getOptions,
    getCarListBySelect,
    doAddMyCar,
    doUpdateFavorite,
    doDeleteMyCar
  }
})
